<template>
  <div class="photo-text-section">
    <div
      class="md:flex"
      :class="{ 'md:flex-row-reverse': isReversed }"
    >
      <div class="md:flex-1">
        <OImage
          :desktop="image.desktop"
          :mobile="image.mobile"
          :src="image.fallback"
          img-class="md:rounded"
        />
      </div>
      <div class="md:flex-1">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'

export default {
  name: 'PhotoTextSection',
  components: {
    OImage
  },
  props: {
    image: {
      type: Object,
      required: true,
      validator: obj => ['mobile', 'desktop', 'src'].every(prop => obj.hasOwnProperty(prop))
    },
    isReversed: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
@screen md {
  .photo-text-section {
    @apply mx-auto;
    max-width: 91rem;
  }
}
</style>
